import { useAppSelector } from '@/redux/hooks';
import { getItemSummaryCatalogId, getItemSummaryPromoted } from '@/redux/modules/item/summary/itemSummary.selectors';

import { useItemOrPriceResultLink } from './useItemOrPriceResultLink';

/**
 * useCoverLotItemMeta - bundles the per-item metadata needed to render a cover lot image.
 * Call once per cover lot slot instead of wiring separate selectors for each metadata field.
 *
 * @param itemId item to fetch metadata for; pass 0 for a slot with no item
 * @returns catalog id, promoted flag, and item URL for the cover lot item
 */
export const useCoverLotItemMeta = (itemId: number) => {
    const catalogId = useAppSelector((state) => getItemSummaryCatalogId(state, itemId));
    const promoted = useAppSelector((state) => getItemSummaryPromoted(state, itemId));
    const url = useItemOrPriceResultLink(itemId, true);

    return { catalogId, promoted, url };
};
